import React, { useState } from 'react';

const cor = '#B51013';

export function useConfirmar() {
  const [estado, setEstado] = useState(null);

  const confirmar = (opcoes) => {
    return new Promise((resolve) => {
      setEstado({ ...opcoes, resolve });
    });
  };

  const fechar = (resultado) => {
    if (estado) estado.resolve(resultado);
    setEstado(null);
  };

  const Modal = estado ? (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: '16px',
    }}
      onClick={(e) => { if (e.target === e.currentTarget) fechar(false); }}
    >
      <div style={{
        background: '#fff', borderRadius: '12px', padding: '28px',
        maxWidth: '400px', width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
      }}>
        {estado.icone && (
          <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: estado.iconeBg || '#FCEBEB', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
            {estado.icone}
          </div>
        )}
        <div style={{ fontSize: '15px', fontWeight: '700', color: '#1a1a1a', marginBottom: '8px', textAlign: 'center' }}>
          {estado.titulo || 'Confirmar'}
        </div>
        <div style={{ fontSize: '13px', color: '#666', marginBottom: '24px', textAlign: 'center', lineHeight: '1.5' }}>
          {estado.mensagem}
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button onClick={() => fechar(false)} style={{ padding: '9px 20px', background: 'none', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', color: '#666', cursor: 'pointer', flex: 1 }}>
            {estado.cancelar || 'Cancelar'}
          </button>
          <button onClick={() => fechar(true)} style={{
            padding: '9px 20px',
            background: estado.perigoso ? cor : '#1D9E75',
            color: '#fff', border: 'none', borderRadius: '8px',
            fontSize: '13px', fontWeight: '600', cursor: 'pointer', flex: 1,
          }}>
            {estado.confirmar || 'Confirmar'}
          </button>
        </div>
      </div>
    </div>
  ) : null;

  return { confirmar, Modal };
}
